import { Emitter } from "mitt";
import { createContext, useContext } from "react";

import { UseLandingsAuthModel } from "../../hooks";
import { GlobalLandingsAppEvents } from "../../models";

export const initialLandingUseAuthModel = {
  isLoggedIn: false,
};

export interface ICompanyScopeLandingsContext {
  auth: UseLandingsAuthModel;
  companyId?: number;
  isDynamicLandingPage?: boolean;
  eventEmitter?: Emitter<GlobalLandingsAppEvents>;
}

const initialContext: ICompanyScopeLandingsContext = {
  auth: initialLandingUseAuthModel,
};

const CompanyScopeLandingsContext =
  createContext<ICompanyScopeLandingsContext>(initialContext);

CompanyScopeLandingsContext.displayName = "Company Scope Landings";

export const useCompanyScopeLandingsContext =
  (): ICompanyScopeLandingsContext => useContext(CompanyScopeLandingsContext);

export { CompanyScopeLandingsContext };
